export const convertDateTime = (timestamp: number | null): string => {
  if (timestamp == null) return '-';

  return new Date(timestamp * 1000).toLocaleString('ja-JP', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const convertDateToYearMonth = (timestamp: number | null): string => {
  if (timestamp == null) return '-';

  return new Date(timestamp * 1000).toLocaleDateString('ja-JP', {
    year: 'numeric',
    month: 'long',
  });
};
